import RouterLink from '@app/components/RouterLink';
import DevText from '@app/components/Text';
import { Colors } from '@blueprintjs/core';
import React from 'react';
import {
    NotificationResource,
    SubscriptionResource,
    SubscriptionPauseEnabledActivityPayloadResource,
} from 'dy-frontend-http-repository/lib/modules/Notification/resources';
import { Endpoints } from '@app/data/consts';
import NotificationTemplate from '../../../../NotificationTemplate';
import moment from 'moment';

export interface SubscriptionPauseEnabledNotificationProps {
    authorizedUserId: ID;
    notification: NotificationResource;
    subscription: SubscriptionResource | null;
    dismiss: () => Promise<void>;
}

type Props = SubscriptionPauseEnabledNotificationProps;

const SubscriptionPauseEnabledNotification: React.FC<Props> = ({ notification, subscription, dismiss }) => {
    const renderContent = () => {
        if (!subscription) {
            // This is bad, subscription is NOT found, which should not happen
            return <DevText color={Colors.RED2}>Subscription was not found</DevText>;
        }

        const payload: SubscriptionPauseEnabledActivityPayloadResource | null = notification.activity.payload;
        if (!payload) {
            // This is bad, there should be payload, but for some reason it is not there
            return <DevText color={Colors.RED2}>Payload was not found</DevText>;
        }

        const renderPausedLabel = () => {
            if (payload.external_resume_at === null) {
                // Paused indefinitely

                return 'paused indefinitely';
            } else {
                return `paused until ${moment(payload.external_resume_at).format('D MMM YYYY, HH:mm')}`;
            }
        };

        return (
            <div>
                <DevText running>
                    <RouterLink to={Endpoints.SUBSCRIPTION.replace(':subscriptionId', subscription.id)}>
                        Subscription
                    </RouterLink>{' '}
                    of{' '}
                    <RouterLink to={Endpoints.CLIENT_BILLING.replace(':clientId', subscription.user.id)}>
                        {subscription.user.first_name} {subscription.user.last_name}
                    </RouterLink>{' '}
                    {renderPausedLabel()}
                </DevText>
            </div>
        );
    };

    return (
        <NotificationTemplate
            title="Subscription paused"
            icon="pause"
            at={notification.activity.at}
            content={renderContent()}
            dismiss={dismiss}
        />
    );
};

export default SubscriptionPauseEnabledNotification;
